<div class="transition-opacity ease-in-out duration-1000" [ngClass]="(show$ | async) ? 'opacity-100' : 'opacity-0'">
  <ng-content></ng-content>
</div>
